var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7331 4.26692C28.1142 3.64826 27.275 3.30072 26.4 3.30072C25.5249 3.30072 24.6857 3.64826 24.0669 4.26692L11.55 16.7838V21.45H16.2162L28.7331 8.93312C29.3517 8.31427 29.6993 7.47506 29.6993 6.60002C29.6993 5.72497 29.3517 4.88576 28.7331 4.26692Z",
    fill: "#627D98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29999 9.89998C3.29999 9.02476 3.64767 8.18539 4.26654 7.56652C4.88541 6.94765 5.72477 6.59998 6.59999 6.59998H13.2C13.6376 6.59998 14.0573 6.77381 14.3667 7.08325C14.6761 7.39268 14.85 7.81237 14.85 8.24998C14.85 8.68758 14.6761 9.10727 14.3667 9.4167C14.0573 9.72614 13.6376 9.89998 13.2 9.89998H6.59999V26.4H23.1V19.8C23.1 19.3624 23.2738 18.9427 23.5833 18.6332C23.8927 18.3238 24.3124 18.15 24.75 18.15C25.1876 18.15 25.6073 18.3238 25.9167 18.6332C26.2261 18.9427 26.4 19.3624 26.4 19.8V26.4C26.4 27.2752 26.0523 28.1146 25.4334 28.7334C24.8146 29.3523 23.9752 29.7 23.1 29.7H6.59999C5.72477 29.7 4.88541 29.3523 4.26654 28.7334C3.64767 28.1146 3.29999 27.2752 3.29999 26.4V9.89998Z",
    fill: "#627D98"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d3f2be6f2d22a2e608f4d4a1471b1947.svg";
export { ForwardRef as ReactComponent };